import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'

VueClipboard.config.autoSetContainer
Vue.use(VueClipboard)



// WEBPACK FOOTER //
// ./src/plugins/vue-clipboard-2.js